import CheckCircleIcon from '@mui/icons-material/CheckCircle';
//import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import EditIcon from '@mui/icons-material/Edit';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import SearchIcon from '@mui/icons-material/Search';
import {
  Autocomplete,
  Badge,
  Box,
  Button,
  Checkbox,
  Chip,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  LinearProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import Popover from '@mui/material/Popover';
import {
  DataGridPro,
  GridColDef,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  useGridApiRef
} from '@mui/x-data-grid-pro';
import moment from 'moment';
import React, { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import { PopupComponent } from 'src/components/common/PopupComponent';
import CustomNoRowsOverlay from 'src/components/eTMF/search/CustomNoRowsOverlay';
import SearchHierarchy from 'src/components/layouts/DashboardLayout/SearchHierarchy';
import { AppState, store } from 'src/store';
import { useAppSelector } from 'src/store/hooks';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import DocManagementService from '../documentUpload/service/DocManagementService';
import ChartComponent from './ChartComponent';
import './planning.scss';
import { CustomPagination } from 'src/util/DataTableFooter';

const PlanningComponent = (props: any) => {
  const [planningData, setPlanningData] = useState<any>([]);
  const [typeList, setTypeList] = useState<any>([]);
  const [subTypeList, setSubTypeList] = useState<any>([]);
  const [artifactNameList, setArtifactNameList] = useState<any>([]);
  const [artifactNumberList, setArtifactNumberList] = useState<any>([]);
  const [loading, setLoading] = useState<any>(false);
  const [studyValue, setStudyValue] = useState<string>('');
  const [countryValue, setCountryValue] = useState<string>('');
  const [siteValue, setSiteValue] = useState<string>('');
  const [popoverRows, setPopoverRows] = useState<any>([]);
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const [alldocumentStatus, setAlldocumentStatus] = useState();
  const [pageSize, setPageSize] = useState<number>(10);
  const [page, setPage] = useState<number>(0);
  const [reason, setReason] = useState<string>();
  const [openDialog, setOpenDialog] = useState(false);
  const [notify, setNotify] = useState<any>([]);
  const [anchorEl, setAnchorEl] = useState<any | null>(null);
  const [isProcessing, setProcessing] = useState(false);
  const [disableOK, setDisableOK] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const [rowCount, setRowCount] = useState<number>(0);
  const [artifactName, setArtifactName] = useState();
  const SearchHierarchyDetail: any = useSelector((state: AppState) => state.searchHierarchyDetails);
  const [fields, setFields] = useState<any>({
    core_recomended: false
  });
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    core_recomended: false
  });
  const isfLevel = 'Site';
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  let IsfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (IsfLevel === '--') {
    IsfLevel = 'Study';
  }
  const [rowData, setRowData] = useState({
    isf_level_map_id: '',
    isf_doc_level: '',
    isf_doc_study: '',
    isf_doc_country: '',
    isf_doc_site: '',
    isf_artifact_number: '',
    isf_artifact_name: '',
    isSelected: false,
    reason_selected: '',
    notify_user: '',
    updated_by: '',
    core_recommended: '',
    study: '',
    country: '',
    site: '',
    need_to_send_to_etmf: ''
  });

  const docService = new DocManagementService();
  const { checkPermission } = usePermissionWrapper();
  const apiRef = useGridApiRef();
  const open = Boolean(anchorEl);
  const isDataAvailable: any = useAppSelector(state => state.user.user?.userdataavailable);
  const user: any = useAppSelector(state => state.user.user); //logged in user data
  const userName = `${user.firstName + ' ' + user.lastName}`;

  // count section start
  const alldocumentStatusData: any = planningData.length > 0 ? [alldocumentStatus].map(item => item) : [];
  const approvalCount = alldocumentStatusData[0]?.isf_doc_Ready_for_approval_count;
  const approvedCount = alldocumentStatusData[0]?.isf_doc_approved_count;
  const expectedCount = alldocumentStatusData[0]?.isf_doc_expected_count;
  const rejectedCount = alldocumentStatusData[0]?.isf_doc_rejected_count;
  const totalCount = alldocumentStatusData[0]?.isf_doc_total_count;
  const uploadedCount = alldocumentStatusData[0]?.isf_doc_uploaded_count;
  const sentToTmfCount: any = alldocumentStatusData[0]?.isf_doc_sent_to_tmf_count;
  const sentToTmf = [sentToTmfCount];
  const approved = approvedCount;
  const total = totalCount;
  const artifacts: any = total > 0 ? `${(((approved + sentToTmfCount) / total) * 100).toFixed(2) || 0}` : `0`;

  const tabs = [
    // {
    // key: 1,
    // label: <ContentPasteGoIcon />,
    // value: 'Sent To TMF',
    // style: 'sentTMF',
    // count: sentToTmfCount
    // },
    {
      key: 2,
      label: <CheckCircleIcon />,
      value: 'Approved',
      style: 'approved',
      count: approvedCount
    },
    {
      key: 3,
      label: <SearchIcon />,
      value: 'Ready for Approval',
      style: 'ready-for-approval',
      count: approvalCount
    },
    {
      key: 4,
      label: <EditIcon />,
      value: 'Uploaded',
      style: 'uploaded',
      count: uploadedCount
    },
    {
      key: 5,
      label: <PendingActionsIcon />,
      value: 'Expected',
      style: 'inprogress',
      count: expectedCount
    },
    {
      key: 6,
      label: <DoNotDisturbIcon />,
      value: 'Rejected',
      style: 'rejected',
      count: rejectedCount
    }
  ];
  // count section end

  // for DataGrid columns
  const columns: GridColDef[] = [
    {
      field: 'isf_doc_type',
      headerName: 'Type',
      flex: 1,
      minWidth: 160,
      type: 'singleSelect',
      valueOptions: typeList
    },
    {
      field: 'isf_doc_subtype',
      headerName: 'Subtype',
      flex: 1,
      minWidth: 180,
      type: 'singleSelect',
      valueOptions: subTypeList
    },
    {
      field: 'isf_artifact_name',
      headerName: 'Artifact Name',
      minWidth: 230,
      flex: 1,
      type: 'singleSelect',
      valueOptions: artifactNameList,
      renderCell: params => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <span className="artNameinTd">{params.formattedValue}</span>
            {params.row.sub_artifact_count !== 0 && (
              <IconButton
                aria-label="Sub-Artifact Information"
                className="datareview-help-icon"
                onClick={() => handlePopoverOpen(params.row)}
                onMouseLeave={handlePopoverClose}
              >
                <Badge badgeContent={params.row.sub_artifact_count} color="primary" className="badgeinTd"></Badge>
              </IconButton>
            )}
          </div>
        );
      }
    },
    {
      field: 'isf_artifact_number',
      headerName: 'Artifact Number',
      minWidth: 120,
      flex: 1,
      type: 'singleSelect',
      valueOptions: artifactNumberList
    },
    {
      field: 'isf_doc_status',
      headerName: 'Status',
      minWidth: 150,
      type: 'singleSelect',
      valueOptions: ['Uploaded', 'Ready for approval', 'Approved', 'Rejected', 'Expected', 'Sent To TMF']
    },
    {
      field: 'need_to_send_to_etmf',
      headerName: 'Need to be Sent to TMF',
      minWidth: 130,
      flex: 1,
      valueOptions: ['Yes', 'No'],
      type: 'singleSelect',
      renderCell: params => {
        return (
          <Checkbox
            checked={params.row.need_to_send_to_etmf === 'Yes'}
            onClick={() => {
              sentToTMF(params.row);
            }}
            disabled={!checkPermission('update_configuration')}
          />
        );
      }
    },
    {
      field: 'core_recommended',
      headerName: 'Include in Configuration',
      flex: 1,
      minWidth: 170,
      type: 'singleSelect',
      disableExport: true,
      valueOptions: ['Core', 'Recommended'],
      renderCell: params => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Checkbox
              checked={params.row.isSelected}
              onClick={() => {
                handleClickOpenDialog(params.row);
              }}
              disabled={!checkPermission('update_configuration')}
            />{' '}
            <Chip label={params.row.core_recommended} size="small" className="fontBoldChip" />
          </div>
        );
      }
    },
    {
      field: 'core_recomended',
      headerName: 'Core/Recomended',
      filterable: false,
      hideable: false,
      hide: true,
      valueGetter: (params: any) => `${params.row.core_recommended} (${params.row.isSelected})`
    }
  ];

  /* Event Handling */

  // row popover start
  const handlePopoverOpen = async (row: any) => {
    const rowId = row.id;
    const rowData = planningData.find((el: any) => el.id == rowId);
    getRowData(rowData.isf_artifact_number, rowData.study, rowData.country, rowData.site);
    setAnchorEl(true);
    setArtifactName(rowData.tmf_artifact_name);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const getRowData = async (number: string, study: string, country: string, site: string) => {
    setPopoverRows([]);
    const res: any = await docService.getMasterDocumentArtifactBased(
      false,
      number,
      study,
      country,
      site,
      process.env.REACT_APP_NAME,
      'ISF planning',
      isfLevel
    );
    if (res?.error) {
      setPopoverRows([]);
    } else {
      const docList: any = [];
      for (const doc of res.data.selected_data) {
        docList.push(doc.document_data);
      }
      setPopoverRows(docList);
    }
  };
  // row popover end

  // checkbox Dailog start
  const handleClickOpenDialog = (row: any) => {
    setDisableOK(true);
    setRowData(row);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    if (reason || notify) {
      setOpenConfirmExit(true);
    } else {
      setReason('');
      setNotify('');
      setOpenDialog(false);
    }
  };

  const handleChangeSingle = (event: any, values: any) => {
    if (values) setDisableOK(false);
    else setDisableOK(true);
    const singleUser: any = [];
    singleUser.push(values);
    setNotify(singleUser);
  };

  const handleReason = (e: any) => {
    setReason(e.target.value);
  };

  const sentToTMF = async (rowData: any) => {
    const data = {
      isf_level_map_id: rowData.isf_level_map_id,
      isf_doc_level: rowData.isf_doc_level,
      isf_doc_study: rowData.study === '--' ? '' : rowData.study,
      isf_doc_country: rowData.country === '--' ? '' : rowData.country,
      isf_doc_site: rowData.site === '--' ? '' : rowData.site,
      isf_artifact_number: rowData.isf_artifact_number,
      isf_artifact_name: rowData.isf_artifact_name,
      is_selected: rowData.isSelected,
      need_sent_to_tmf: rowData.need_to_send_to_etmf === 'Yes' ? 'No' : 'Yes',
      updated_by: userName
    };
    const Response: any = await docService.updatePlanningField(
      data,
      process.env.REACT_APP_NAME,
      'ISF planning',
      rowData.isf_artifact_name
    );
    if (Response.data) {
      store.dispatch(setSnackbarMessage('EDL configuration is updated successfully.', 'success'));
    } else {
      store.dispatch(setSnackbarMessage('Error in updating EDL configuration.', 'error'));
    }
    getAllPlanningData(rowData.study, rowData.country, rowData.site, page * pageSize, pageSize);
  };
  const handleConfirmDialog = async () => {
    setProcessing(true);
    const tempArray: any = [];

    planningData.map((item: any) => {
      if (item.isf_level_map_id === rowData.isf_level_map_id) {
        tempArray.push({ ...item, isSelected: !rowData.isSelected });
      } else {
        tempArray.push(item);
      }
    });

    if (rowData) {
      const data = {
        isf_level_map_id: rowData.isf_level_map_id,
        isf_doc_level: rowData.isf_doc_level,
        isf_doc_study: rowData.study === '--' ? '' : rowData.study,
        isf_doc_country: rowData.country === '--' ? '' : rowData.country,
        isf_doc_site: rowData.site === '--' ? '' : rowData.site,
        isf_artifact_number: rowData.isf_artifact_number,
        isf_artifact_name: rowData.isf_artifact_name,
        is_selected: !rowData.isSelected,
        need_sent_to_tmf: rowData.need_to_send_to_etmf,
        reason_selected: reason,
        notify_user: notify.length > 0 ? `${notify[0].firstName + ' ' + notify[0].lastName}` : '',
        updated_by: userName
      };
      const Response: any = await docService.updatePlanningField(
        data,
        process.env.REACT_APP_NAME,
        'ISF planning',
        rowData.isf_artifact_name
      );
      if (Response.data) {
        setProcessing(false);
        store.dispatch(setSnackbarMessage('EDL configuration is updated successfully.', 'success'));
      } else {
        setProcessing(false);
        store.dispatch(setSnackbarMessage('Error in updating EDL configuration.', 'error'));
      }
    }
    setReason('');
    setNotify('');
    setOpenDialog(false);
    getAllPlanningData(rowData.study, rowData.country, rowData.site, page * pageSize, pageSize);
  };
  // checkbox Dailog start

  const getAllUsers = async () => {
    setProcessing(true);
    const response: any = await docService.getAllUsers(
      selectedStudy,
      isfLevel,
      artifactName ? artifactName : '--',
      selectedCountry,
      selectedSite
    );
    const filtered = response.data.filter(function (el: any) {
      return el.firstName !== null;
    });
    if (response?.data) {
      setUsersList(filtered);
    }
    setProcessing(false);
  };
  /* Event Handling */

  const getAllPlanningData = async (study: string, country: string, site: string, from: number, size: number) => {
    setStudyValue(study);
    setCountryValue(country);
    setSiteValue(site);
    let count = 1;
    setLoading(true);
    if (site === '--' || site === '') {
      setPlanningData([]);
      setRowCount(0);
      setLoading(false);
    } else {
      const res: any = await docService.getAllPlanning(
        isfLevel,
        study,
        country,
        site,
        process.env.REACT_APP_NAME,
        'ISF planning',
        from,
        size
      );
      const documentMetrics = res?.data?.isf_document_metrics;

      setAlldocumentStatus(documentMetrics);
      const planArray: any = [];
      if (res.error) {
        store.dispatch(setSnackbarMessage('Error in Getting Planning list', 'error'));
      } else if (res.data.isf_document_items.length <= 0) {
        setPlanningData([]);
        setLoading(false);
      } else {
        const types: Array<string> = [];
        const subTyps: Array<string> = [];
        const artifactNames: Array<string> = [];
        const artifactNumbers: Array<string> = [];

        for (const data of res.data.isf_document_items) {
          const planObj = {
            isf_doc_type: data.isf_doc_type,
            isf_doc_subtype: data.isf_doc_subtype,
            isf_artifact_name: data.isf_artifact_name,
            isf_artifact_number: data.isf_artifact_number,
            isf_doc_status: data.sent_to_tmf_sub_status === null ? data.isf_doc_status : data.sent_to_tmf_sub_status,
            core_recommended: data.core_recommended,
            core_recomended: data.core_recommended, //for export duplicate added
            id: count++,
            isf_level_map_id: data.isf_level_map_id,
            isSelected: data.is_selected,
            isf_doc_country: data.isf_doc_country,
            isf_doc_level: data.isf_doc_level,
            isf_doc_site: data.isf_doc_site,
            isf_doc_study: data.isf_doc_study,
            sub_artifact_count: data.sub_artifact_count,
            need_to_send_to_etmf: data.need_to_send_to_etmf,
            study: study,
            country: country,
            site: site
          };
          planArray.push(planObj);
          types.push(data.isf_doc_type);
          subTyps.push(data.isf_doc_subtype);
          artifactNames.push(data.isf_artifact_name);
          artifactNumbers.push(data.isf_artifact_number);
        }
        setTypeList([...new Set(types)]);
        setSubTypeList([...new Set(subTyps)]);
        setArtifactNameList([...new Set(artifactNames)]);
        setArtifactNumberList([...new Set(artifactNumbers)]);
      }

      setPlanningData(planArray);
      setLoading(false);
      setRowCount(res.data.record_count);
    }
  };

  //  Export custom functionality start
  const CustomToolbar = () => {
    const { userPreferedDateFormat } = usePreferedDateFormat();
    const { checkPermission } = usePermissionWrapper();

    Object.keys(fields).forEach((key: string) => {
      if (fields[key] === true) {
        delete fields[key];
      }
    });
    const removedColumns: any = Object.keys(fields);
    const columnFields = [];
    const exportFields = [];
    for (const column of columns) {
      if (column.field !== 'core_recomended') {
        columnFields.push(column.field);
      }
    }

    for (let i = 0; i <= columnFields.length - 1; i++) {
      if (removedColumns.indexOf(columnFields[i]) <= 0) {
        if (columnFields[i] === 'core_recommended') {
          exportFields.push(columnFields[i]);
          const index = exportFields.indexOf('core_recommended');
          exportFields.splice(index, 1, 'core_recomended');
        } else {
          exportFields.push(columnFields[i]);
        }
      }
    }

    const cValue = countryValue === '--' ? '' : `|${countryValue}`;
    const sValue = siteValue === '--' ? '' : `${siteValue}`;
    const exportDateFormat = userPreferedDateFormat.includes('/')
      ? userPreferedDateFormat.replaceAll('/', '_')
      : userPreferedDateFormat.replaceAll('-', '_');
    const documentName =
      `${sValue} | Planning |` + moment(new Date()).format(`${exportDateFormat.toUpperCase()} hh_mm A`);
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton onResize={undefined} onResizeCapture={undefined} nonce={undefined} />
        <GridToolbarFilterButton onResize={undefined} onResizeCapture={undefined} nonce={undefined} />
        <GridToolbarDensitySelector onResize={undefined} onResizeCapture={undefined} nonce={undefined} />
        {checkPermission('export_planning') && (
          <GridToolbarExport
            csvOptions={{
              fileName: documentName,
              fields: exportFields
            }}
          />
        )}
      </GridToolbarContainer>
    );
  };
  //  Export custom functionality end

  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (SearchHierarchyDetail?.data[0]?.Site !== undefined) {
      if (pageSize === 10 || pageSize === 20 || pageSize === 30) {
        if (page * pageSize > rowCount - 1) {
          setPage(0);
          getAllPlanningData(
            SearchHierarchyDetail?.data[0]?.Study,
            SearchHierarchyDetail?.data[0]?.Country,
            SearchHierarchyDetail?.data[0]?.Site,
            0,
            pageSize
          );
        } else
          getAllPlanningData(
            SearchHierarchyDetail?.data[0]?.Study,
            SearchHierarchyDetail?.data[0]?.Country,
            SearchHierarchyDetail?.data[0]?.Site,
            page * pageSize,
            pageSize
          );
      }
      getAllUsers();
    }
  }, [page, pageSize, SearchHierarchyDetail?.data[0]?.Site]);

  const width = IsfLevel === 'Site' ? '428px' : '248px';
  return (
    <div>
      <SearchHierarchy searchData={getAllPlanningData} />
      {isDataAvailable != null && isDataAvailable === false ? (
        <div className="no-data-class">
          <h3>No Data access available!</h3>
        </div>
      ) : (
        <>
          <Grid container className="chart-wrapper">
            <Grid item sx={{ width: width, height: '78px', justifyContent: 'space-between' }}>
              <ChartComponent alldocumentStatus={alldocumentStatusData} />
              <Grid
                className="chart-description"
                sx={{ display: 'inline-block', ml: 1.5, top: '-12px', position: 'relative' }}
              >
                <div className="completed">
                  <strong>
                    {Math.round(artifacts)}
                    <span>%</span>
                  </strong>
                  <br />
                  <Box sx={{ letterSpacing: -0.5 }}>Artifacts Complete</Box>
                </div>
              </Grid>
            </Grid>
            <Grid item xs className="chart-description">
              <ul>
                {tabs.map((item: any, index: number) => {
                  return (
                    <li className={item.style} key={index}>
                      <strong>
                        {item.label}
                        {item.count || 0}
                      </strong>{' '}
                      {item.value}
                    </li>
                  );
                })}
              </ul>
            </Grid>
          </Grid>

          <Grid container>
            <Grid md={12}>
              <div style={{ height: '70vh', width: '100%' }}>
                <DataGridPro
                  apiRef={apiRef}
                  rows={planningData.length > 0 ? planningData : []}
                  columns={columns}
                  disableColumnSelector={false}
                  components={{
                    NoRowsOverlay: CustomNoRowsOverlay,
                    Toolbar: CustomToolbar,
                    Pagination: CustomPagination,
                    NoResultsOverlay: () => (
                      <Stack height="100%" alignItems="center" justifyContent="center">
                        No rows
                      </Stack>
                    )
                  }}
                  //checkboxSelection
                  columnVisibilityModel={columnVisibilityModel}
                  onColumnVisibilityModelChange={(newModel: any) => {
                    setColumnVisibilityModel(newModel);
                    setFields(newModel);
                    const hideColumsArr: any = [];
                    for (const obj of columns) {
                      if (newModel[obj.field] == false) {
                        hideColumsArr.push(false);
                      } else {
                        hideColumsArr.push(true);
                      }
                    }
                  }}
                  disableSelectionOnClick
                  page={page}
                  onPageChange={newPage => setPage(newPage)}
                  pageSize={pageSize}
                  rowCount={rowCount}
                  onPageSizeChange={newPageSize => setPageSize(newPageSize)}
                  rowsPerPageOptions={[10, 20, 30]}
                  pagination
                  paginationMode="server"
                  className="planning-grid theme-filter-spacing"
                  loading={loading}
                  initialState={{
                    sorting: {
                      sortModel: [{ field: 'isf_artifact_number', sort: 'asc' }]
                    }
                  }}
                />
                {popoverRows.length > 0 && (
                  <Popover
                    sx={{
                      pointerEvents: 'none'
                    }}
                    open={open}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: 'center',
                      horizontal: 'center'
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'left'
                    }}
                    onClose={handlePopoverClose}
                  >
                    <Box sx={{ flexGrow: 1, p: 2 }} className="subArtifactPopContent">
                      <TableContainer>
                        <Table sx={{ minWidth: 540 }} size="small" aria-label="Sub-artifacts details">
                          <TableHead>
                            <TableRow>
                              <TableCell>Document Name</TableCell>
                              <TableCell width={90}>Status</TableCell>
                              <TableCell>Version</TableCell>
                              <TableCell>Created By</TableCell>
                              <TableCell>Created On</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {popoverRows.length > 0 &&
                              popoverRows.map((row: any, index: number) => (
                                <TableRow key={index}>
                                  <TableCell>{row.isf_document_name}</TableCell>
                                  <TableCell>{row.isf_doc_status}</TableCell>
                                  <TableCell>
                                    <Chip
                                      label={`Ver ${parseFloat(row.isf_doc_version_number).toFixed(1)}`}
                                      size="small"
                                      variant="outlined"
                                    />
                                  </TableCell>
                                  <TableCell>{row.isf_doc_viewer_created_by}</TableCell>
                                  <TableCell>
                                    {moment(new Date(row.created_on)).format(userPreferedDateFormat.toUpperCase())}
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </Popover>
                )}
              </div>
            </Grid>
          </Grid>

          <PopupComponent open={openDialog} maxWidth="sm">
            <DialogContent className="ConfirmDialog">
              {isProcessing && <LinearProgress />}
              <Typography variant="h6" component="div" sx={{ mb: 1 }}>
                Confirm
              </Typography>
              <DialogContentText sx={{ mb: 1 }}>
                {rowData.core_recommended === 'Recommended'
                  ? rowData.isSelected
                    ? 'Are you sure you want to remove this recommended artifact from the configuration? If so, please provide a reason.'
                    : 'Are you sure you want to add this recommended artifact to the configuration? If so, please provide a reason.'
                  : rowData.isSelected
                  ? 'Are you sure you want to remove this core artifact from the configuration? If so, please provide a reason'
                  : 'Are you sure you want to add this core artifact to the configuration? If so, please provide a reason'}
              </DialogContentText>

              <TextField
                autoFocus
                id="name"
                label="Reason"
                type="text"
                fullWidth
                variant="standard"
                inputProps={{ maxLength: 250 }}
                onChange={e => handleReason(e)}
                value={reason?.trimLeft()}
                disabled={isProcessing}
              />
              <FormControl fullWidth variant="standard" sx={{ my: 3 }}>
                <Autocomplete
                  disabled={isProcessing}
                  id="tags-standard-users"
                  options={usersList}
                  getOptionLabel={(option: any) =>
                    option.firstName + ' ' + option.lastName + ' (' + option?.email + ')'
                  }
                  onChange={handleChangeSingle}
                  renderInput={params => (
                    <TextField
                      {...params}
                      variant="standard"
                      label="Notify System Admin for Review"
                      placeholder="Users"
                    />
                  )}
                />
              </FormControl>
            </DialogContent>
            <DialogActions sx={{ mb: 0.5 }}>
              <Button disabled={isProcessing} onClick={handleCloseDialog} className="grey-btn">
                Cancel
              </Button>
              <Button disabled={isProcessing} onClick={handleConfirmDialog}>
                Ok
              </Button>
            </DialogActions>
          </PopupComponent>
        </>
      )}
      <div>
        <PopupComponent
          open={openConfirmExit}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
          child={true}
        >
          <DialogTitle id="alert-dialog-title">
            <b>Please Confirm</b>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              All unsaved changes will be lost. Are you sure you want to exit before saving your changes?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenConfirmExit(false);
              }}
              className="grey-btn"
            >
              CLOSE
            </Button>
            <Button
              onClick={() => {
                setOpenDialog(false);
                setOpenConfirmExit(false);
                setReason('');
                setNotify('');
              }}
            >
              EXIT
            </Button>
          </DialogActions>
        </PopupComponent>
      </div>
    </div>
  );
};
export default memo(PlanningComponent);
